export const LABELS = {
  labelDeleteDialogTitle: 'Permanently delete label',
  labelDeleteDialogAriaLabel: 'Delete label?',
  cancelButtonText: 'Cancel',
  deleteButtonText: 'Delete',
  deleteLabelButtonText: 'Delete this label',
  deleteLabelWarningPermanent: 'Once you delete this label, you will not be able to see it again.',
  deleteLabelAssociatedIssuesNote: 'Deleting this label will remove it from all issues and pull requests.',
}
